<template>
  <div>
    <v-container
      v-for="(a, index) in analyses"
      :key="`vca-${a.index}-${a.version}`"
      fluid
      fill-width
      class="ma-0 pa-0 my-3"
    >
      <v-row class="ma-0 pa-0">
        <v-col class="ma-0 pa-0">
          <analysis
            :id="'analysis-' + a.index + '-' + a.version"
            :ref="'analysis-' + a.index"
            :key="'a-' + a.collection.id + '-' + a.index + '-' + a.version"
            :analysis="a"
            :title="'ANALYSIS ' + (a.index > 0 ? a.index : '-')"
            @deleteAnalysis="deleteAnalysis(index)"
            @refreshAnalysis="refreshAnalysis(index)"
            @cohortColorChange="updateCohortColor"
            @cohortsSelected="cohortsSelected(a, ...arguments)"
            @variablesSelected="variablesSelected(a, ...arguments)"
            @leftTab="leftTab(a, ...arguments)"
            @rightTab="rightTab(a, ...arguments)"
            @expanded="expanded(a, ...arguments)"
            @syncAnalyses="syncAnalyses(a, ...arguments)"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Analysis from '@/components/DataExplorer/Analysis.vue';

export default {
  components: {
    Analysis,
  },
  props: {
    analyses: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    deleteAnalysis(anum) {
      this.$emit('deleteAnalysis', anum);
    },
    updateCohortColor(cc) {
      // propagate event
      this.$emit('cohortColorChange', {
        cohort: cc['cohort'],
        color: cc['color'],
        pattern: cc['pattern'],
      });
    },
    // apply some change to all analyses except the originating one
    _applyToAllExceptOrigin(origin, fn) {
      this.analyses.forEach(a => {
        if (a.index != origin.index) {
          let comp = this.$refs['analysis-' + a.index][0];
          fn(comp, a);
        }
      });
    },
    cohortsSelected(a, sc) {
      this._applyToAllExceptOrigin(a, c => c.setVisibleCohorts(sc));
    },
    variablesSelected(a, sv) {
      this._applyToAllExceptOrigin(a, c => c.setSelectedVariables(sv));
    },
    leftTab(a, lt) {
      this._applyToAllExceptOrigin(a, c => c.setLeftTab(lt));
    },
    rightTab(a, rt) {
      this._applyToAllExceptOrigin(a, c => c.setRightTab(rt));
    },
    expanded(a, ex) {
      this._applyToAllExceptOrigin(a, c => c.setExpanded(ex));
    },
    syncAnalyses(a, sa) {
      if (sa) this._applyToAllExceptOrigin(a, c => c.setSyncAnalyses(false));
    },
    refreshAnalysis(anum) {
      this.$emit('refreshAnalysis', anum);
    },
  },
};
</script>
